import React from 'react';
import { useSelector } from 'react-redux';
import { Filters } from '../util/constants';
import Filter from './filter';
import SortByDropdown from './filters/sort-by-dropdown';
import ShowMapToggle from './show-map-toggle';
import BrandFilter from './filters/brand-filter';
import QuickMoveIn from './quick-move-in';
import ResultsCount from './results-count';
import MobileFilterContainer from './mobile-filter-container';

const MobileFilters = () => {
    return (
        <div className='mobile-filters'>
            <MobileFilterContainer />
            <SortByDropdown />
            <BrandFilter viewport={'mobile'} />
            <ShowMapToggle />
        </div>
    )
}

const DesktopFilters = () => {
    const mapState = useSelector((state) => state.map);
    return (
        <div className='desktop-filters'>
            <div className='primary-filters bg-white d-flex justify-content-between align-items-center'>
                <div className="d-flex flex-wrap">
                    <Filter filterType={Filters.STATE_FILTER} positionLeft hideFooter />
                    <Filter filterType={Filters.METRO_FILTER} hideFooter />
                    <Filter filterType={Filters.CITY_FILTER} hideFooter />
                    <Filter filterType={Filters.PRICE_RANGE} />
                    <Filter filterType={Filters.BEDS_BATHS} />
                    <Filter filterType={Filters.HOME_TYPES} />
                    <Filter filterType={Filters.MORE} />
                    <Filter filterType={Filters.RESET} />
                </div>
                <div className="d-flex">
                    <QuickMoveIn />
                    <ShowMapToggle />
                </div>
            </div>
            <div className={`secondary-filters ${mapState.visible ? 'show-map' : ''}`}>
                <ResultsCount />
                <BrandFilter viewport={'desktop'} />
                <SortByDropdown />
            </div>
        </div>
    )
}

function FiltersContainer() {
    return (
        <section className="filters-container" aria-label="filters">
            <MobileFilters />
            <DesktopFilters />
        </section>
    )
}

export default FiltersContainer